import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AlertClassColour, ConfigSystemParams, msSize, OurCompany } from 'src/app/core/consts';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, Observable, throwError } from 'rxjs';
import { CompletedModalFormComponent } from 'src/app/forms-modal/_pop-ups/completed-modal-form/completed-modal-form.component';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { DownloadableFileSet } from 'src/app/core/interfaces/general/downloadable-file';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FileService } from 'src/app/core/services/utelize/general/file-service';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { LastPassKillerService } from 'src/app/core/services/utelize/general/last-pass-killer-service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PlatformInviewService } from 'src/app/core/services/utelize/general/platform-inview-service';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { TypesDownloadFileService } from 'src/app/core/services/utelize/system/type/types-download-file-service';
import { UploadCentreModalFormSearchComponent } from '../../_file-transfers/upload-centre-modal-form-search/upload-centre-modal-form-search.component';
import { WarningModalFormComponent } from 'src/app/forms-modal/_pop-ups/warning-modal-form/warning-modal-form.component';

@Component({
  selector: 'app-upload-centre-modal-form',
  templateUrl: './upload-centre-modal-form.component.html',
  styleUrls: ['./upload-centre-modal-form.component.scss']
})

export class UploadCentreModalFormComponent implements AfterViewInit, OnDestroy, OnInit {
  
  @Output() thisFormCancelled   : EventEmitter<void>=new EventEmitter<void>();
  @Output() thisFormHasBeenSaved: EventEmitter<void>=new EventEmitter<void>();

  @ViewChild('completedModalForm', { static: false }) completedModalForm!: CompletedModalFormComponent;
  @ViewChild('downloadCentreForm', { static: false }) downloadCentreForm!: TemplateRef<void>;
  @ViewChild('uploadSearchForm',   { static: false }) uploadSearchForm!  : UploadCentreModalFormSearchComponent;
  @ViewChild('warningModalForm',   { static: false }) warningModalForm!  : WarningModalFormComponent;

  get allowFileOverwrites    () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.UploadCentreAllowFileOverwrites,     false); }
  get allowWebImageOverwrites() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.UploadCentreAllowWebImageOverwrites, false); }
    
  get modalBackGround() { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                          return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false) }
  
  private downloadFileTypeIdData!: IdAndDescriptionDTO[];
  private initialStatus          : string="Submit file to upload";
  private thisFormModalRef!      : NgbModalRef;
  private uploadFile             : File | null=null;
  private webImageFile           : File | null=null;
   
  public alertColourProgress         : string=AlertClassColour.Green;
  public curUser                     : SystemUserDTO;
  public editExisting                : boolean=false;
  public formSubmitted               : boolean=false;
  public formTitle                   : string ="Upload Centre";
  public ourCompanyName              : string =OurCompany.CompanyNamePascal;
  public progressInformation         : string =this.initialStatus;
  public thisForm!                   : UntypedFormGroup;
  public updateExistingFileUpload    : boolean=false;
  public updateExistingWebImageUpload: boolean=false;
  public usageLimitsChanged          : boolean=false;
  public year                        : number =new Date().getFullYear();

  //#region for Validators etc.
  
  public contentTypeMaxLength: number=100;
  public filenameMaxLength   : number=255;
  public webTextMaxLength    : number=500;
  public webTitleMaxLength   : number=255;

  //#endregion 

  constructor(
    private authenticationService   : AuthenticationService,
    private configSystemService     : ConfigSystemService,
    private exceptionsService       : ExceptionsService,
    private fileService             : FileService,
    private formBuilder             : UntypedFormBuilder,
    private lastPassKillerService   : LastPassKillerService,
    private modalService            : NgbModal,
    private platformInviewService   : PlatformInviewService,
    private typesDownloadFileService: TypesDownloadFileService
  ) {
      this.curUser=this.authenticationService.currentUserObject();
  }
  
  public ngOnInit(): void {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngAfterViewInit(): void {
    try {
      this.lastPassKillerService.start();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngOnDestroy(): void {
    try {
      this.lastPassKillerService.stop();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public resetMainVariables(): void {
    try {
      this.alertColourProgress         =AlertClassColour.Green;
      this.editExisting                =false;
      this.formSubmitted               =false;
      this.progressInformation         =this.initialStatus;
      this.updateExistingFileUpload    =false;
      this.updateExistingWebImageUpload=false;

      this.populateFormFields(this.thisForm, true);

      if (this.thisForm) {
        this.setOrClearValidators("fileData",     true);
        this.setOrClearValidators("webImageData", true);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public openForm(): void {
    try {
      this.resetMainVariables();
      this.refreshDownloadFileTypeData();
      this.setUpForm();
      this.openModal();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private openModal(): void {
    try {
      this.thisFormModalRef=this.modalService.open(this.downloadCentreForm, { backdrop: this.modalBackGround,
                                                                              centered: true,
                                                                              keyboard: false,
                                                                              size    : msSize.Medium });
    }
    catch(e) {
      this.thisFormCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region thisForm
  
  get formOfThis() {
    return this.thisForm.controls;
  }
    
  private setUpForm() {
    try {
      this.buildForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private buildForm() {
    try {
      this.removeFormFields(this.thisForm);
       this.thisForm=this.formBuilder.group({ });
      
      this.addFormFields(this.thisForm);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  private addFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.thisForm) {
        this.addFormControl(this.thisForm, "downloadFileTypeId", "", [Validators.required]);
        this.addFormControl(this.thisForm, "fileData",           "", [Validators.required]);
        this.addFormControl(this.thisForm, "id",                 "", []);
        this.addFormControl(this.thisForm, "visualOrder",        "", [Validators.required]);
        this.addFormControl(this.thisForm, "webImageData",       "", [Validators.required]);
        this.addFormControl(this.thisForm, "webText",            "", [Validators.required, Validators.maxLength(this.webTextMaxLength)]);
        this.addFormControl(this.thisForm, "webTitle",           "", [Validators.required, Validators.maxLength(this.webTitleMaxLength)]);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : boolean | string,
                         validators: Validators) {
    try {
      form.addControl(dataField, new FormControl(
        value,
        validators
      ));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  private removeFormFields(form: UntypedFormGroup) {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  private populateFormFields(formGroup: UntypedFormGroup, clearFields: boolean) {
    try {
      if (formGroup==this.thisForm && this.thisForm && this.thisForm.controls) {
        this.thisForm.controls["downloadFileTypeId"].setValue(clearFields ? "" : "");
        this.thisForm.controls["fileData"          ].setValue(clearFields ? "" : "");
        this.thisForm.controls["id"                ].setValue(clearFields ? "" : "");
        this.thisForm.controls["visualOrder"       ].setValue(clearFields ? "" : "");
        this.thisForm.controls["webImageData"      ].setValue(clearFields ? "" : "");
        this.thisForm.controls["webText"           ].setValue(clearFields ? "" : "");
        this.thisForm.controls["webTitle"          ].setValue(clearFields ? "" : "");
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private enableDisableControls(enabled: boolean) {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public thisFormSubmit() {
    try {
      this.formSubmitted=true;
      
      if (this.thisForm.valid) {
        if (this.editExisting) {
          this.putData();
          
        } else {
          this.uploadData(false);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public thisFormCancel() {
    try {
      this.thisFormCancelled.emit();
      this.thisFormModalRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  //#endregion
  
  //#region Dropdown Arrays
  
  public getDropdownDataObjectArray(fieldName: string) {
    try {
      if (fieldName=="downloadFileTypeId") {
        return this.downloadFileTypeIdData;               
      }
                            
      return undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return undefined;
    }
  }
  
  private getDropdownData(dataSource: Observable<any>, fieldName: string) {
    try {
      if (dataSource) {
        dataSource
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            if (fieldName=="downloadFileTypeId") {
              this.downloadFileTypeIdData=(data as IdAndDescriptionDTO[]);         
            }
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  //#endregion

  //#region Refresh Dropdown Arrays Data

  public refreshDownloadFileTypeData() {
    try {
      this.getDropdownData(this.typesDownloadFileService.getIdAndDescription(), "downloadFileTypeId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  //#endregion

  public uploadFileSelected(event: Event): void {
    try {
      const input=event.target as HTMLInputElement;

      if (input.files && input.files.length>0) {
        this.uploadFile=input.files[0];

      } else {
        this.uploadFile=null;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public webImageFileSelected(event: Event): void {
    try {
      const input=event.target as HTMLInputElement;

      if (input.files && input.files.length>0) {
        this.webImageFile=input.files[0];

      } else {
        this.webImageFile=null;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public uploadData(updateExistingRecord: boolean) {
    try {
      const formData=new FormData();
      formData.append("active",                       "true");
      formData.append("downloadFileTypeID",           this.thisForm.get("downloadFileTypeId")?.value);
      formData.append("enteredBy",                    this.curUser.userId.toString());
      formData.append("fileUpload",                   <Blob>this.uploadFile);
      formData.append("id",                           this.thisForm.get("id")?.value);
      formData.append("updateExistingFileUpload",     this.updateExistingFileUpload ? "TRUE" : "FALSE");
      formData.append("updateExistingRecord",         updateExistingRecord ? "TRUE" : "FALSE");
      formData.append("updateExistingWebImageUpload", this.updateExistingWebImageUpload ? "TRUE" : "FALSE");
      formData.append("visualOrder",                  this.thisForm.get("visualOrder")?.value);
      formData.append("webImageUpload",               <Blob>this.webImageFile);
      formData.append("webText",                      this.thisForm.get("webText")?.value);
      formData.append("webTitle",                     this.thisForm.get("webTitle")?.value);
      
      this.fileService.uploadDownloadableFileData(formData)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.resetMainVariables();

          this.formSubmitted      =false;
          this.alertColourProgress=AlertClassColour.Green;
          this.completedModalForm.openForm(updateExistingRecord ? "Updates Complete" : "Upload Complete", "");
        },
        error: error => {
          this.alertColourProgress=AlertClassColour.Red;
          this.progressInformation=error.message;
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public putData() {
    try {
      if (this.allowFileOverwrites || this.allowWebImageOverwrites) {
        this.uploadData(true);
        return;
      }

      const downloadableFileSet: DownloadableFileSet={
        downloadFileTypeID: this.thisForm.get("downloadFileTypeId")?.value,
        id                : this.thisForm.get("id"                )?.value,
        visualOrder       : this.thisForm.get("visualOrder"       )?.value,
        webText           : this.thisForm.get("webText"           )?.value,
        webTitle          : this.thisForm.get("webTitle"          )?.value
      }
      
      this.fileService.putDownloadableFile(downloadableFileSet)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.resetMainVariables();

          this.formSubmitted      =false;
          this.alertColourProgress=AlertClassColour.Green;
          this.completedModalForm.openForm("Updates Complete", "");
        },
        error: error => {
          this.alertColourProgress=AlertClassColour.Red;
          this.progressInformation=error.message;
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  //#region Downloadable File Search
                 
  public searchForDownloadableFile() {
    try {
      this.uploadSearchForm.openForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
                 
  public searchFormCancelled() {
    try {
      this.populateFormFields(this.thisForm, true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
                 
  public searchGridRowClick(rowId: number) {
    try {
      this.getSearchedFile(rowId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
                 
  private getSearchedFile(rowId: number) {
    try {
      this.fileService.getDownloadableFileById(rowId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.editExisting=true;
          this.thisForm.controls["downloadFileTypeId"].setValue(data.downloadFileTypeID);
          this.thisForm.controls["id"                ].setValue(data.id);
          this.thisForm.controls["visualOrder"       ].setValue(data.visualOrder);
          this.thisForm.controls["webText"           ].setValue(data.webText);
          this.thisForm.controls["webTitle"          ].setValue(data.webTitle);

          this.setOrClearValidators("fileData",     false);
          this.setOrClearValidators("webImageData", false);
         },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
                 
  //#endregion
                 
  public newUpload() {
    try {
      this.resetMainVariables();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onlyAllowDigits(event: KeyboardEvent) {
    try {
      const key=event.key;
      
      if (!/^\d$/.test(key)) {
        event.preventDefault();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public blockNonNumericPaste(event: ClipboardEvent) {
    try {
      const pasted=event.clipboardData?.getData("text");

      if (pasted && !/^\d+$/.test(pasted)) {
        event.preventDefault();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public updateExistingFileUploadRadioChange() {
    try {
      this.setOrClearValidators("fileData", this.updateExistingFileUpload);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public updateExistingWebImageUploadRadioChange() {
    try {
      this.setOrClearValidators("webImageData", this.updateExistingWebImageUpload);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region Set or Clear Validators

  public setOrClearValidators(controlName: string, setValidators: boolean): void {
    try {
      if (setValidators) {
        this.thisForm.get(controlName)?.setValidators([Validators.required]);

      } else {
        this.thisForm.get(controlName)?.clearValidators();
      }

      this.thisForm.get(controlName)?.updateValueAndValidity();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
}
